const countryPickers = document.querySelectorAll('.countryPicker');

if (countryPickers) {
    countryPickers.forEach(countryPicker => {
        const countryPickerLinks = countryPicker.querySelectorAll('.disclosure__item a');
        const countryPickerCountry = countryPicker.querySelector('input[name="country_code"]')
        const countryPickerLang = countryPicker.querySelector('input[name="language_code"]');
        const form = countryPicker.querySelector('form');

        countryPickerLinks.forEach(item => {
            item.addEventListener('click', (e) => {
                const href = item.getAttribute('href');
                if (href === '#') {
                    e.preventDefault();
                    countryPickerCountry.value = item.dataset.value;
                    countryPickerLang.value = item.dataset.lang;
                    form.submit();
                } else if (href.includes('country_code') && href.includes('language_code')) {
                    e.preventDefault();
                    const params = new URLSearchParams(href.includes('?') ? href.split('?')[1] : '');
                    const country = params.get('country_code');
                    const lang = params.get('language_code');
                    if (country) countryPickerCountry.value = country;
                    if (lang) countryPickerLang.value = lang;
                    form.submit();
                } else if (href && href !== '#') {
                    // allow default link behavior
                    e.stopPropagation();
                }
            });
        });
    });
}